module.exports = __webpack_public_path__ + "img/file-contract.ee7ff581.svg";